import React, { useState, useEffect, createRef, forwardRef, useImperativeHandle } from 'react';
import Calendar from '../calendar/Calendar';
import FormField from '../form/FormField';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';
import ReactGA4 from "react-ga4";
import TimingList from './TimingList';
import useWindowDimensions from '../../custom_hooks/useWindowDimensions';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../constants';
import { hex_to_rgba } from '../../custom_functions/hex_to_rgba';
import moment from 'moment-timezone';
import Info from './share/Info';
import ButtonNext from './share/ButtonNext';

const Booking = forwardRef((props, ref) => {
  const { 
    color,
    data,
    locationSearch,
    timezoneName,
    countryCode,
    type,
    timingsData,
    isReschedule,
    isCancelMeeting,
    meetingId,
    setBackToReschedule,
    timingPath,
    getTimings,
    removeTimeslot,
    handleChangeTimezone,
    handleCancelMeetingButton,
    redirectStatus,
    redirectLink,
    handleTimingSelected,
    dateSelected,
    handleDateSelected,
    timingSelected,
    handleConfirmButton, // show confirm button for mobile responsive
    handleShowTimingSelected,
    backButtonRef,
    cancelMeeting,
    showTimingList,
    handleShowTimingList,
    showForm,
    handleShowForm,
    handleFormSubmitRef, //to call submit button from right content
    languageCode,
    userTeamPathId,
    typeUser,
    locationOptions,
    isShareDateTime,
    shareTimings,
    datesSelected,
    timeSlots,
    showPreviewShare,
    showPreviewShareEmail,
    currentDuration,
    scheduleLocation
  } = props;

  const [ showConfirmation, setShowConfirmation ] = useState(false);
  const [ showBookingCalendar, setShowBookingCalendar ] = useState(false);
  const [ timingKey, setTimingKey ] = useState(null);
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const URL_PARAMS = new URLSearchParams(window.location.search);
  const [ currentTimeFromURLParams, setCurrentTimeFromURLParams ] = useState(false);

  useEffect(() => {
    if (URL_PARAMS) {
      let current_time = URL_PARAMS.get('current_time');
      if (current_time) {
        current_time = parseInt(current_time);
        let new_current_time = new Date(current_time);
        let key = `${new_current_time.getFullYear()}-${("0" + (new_current_time.getMonth() + 1)).slice(-2)}`;
        setTimingKey(key);
        let isPrevDate = moment(new_current_time).isBefore(moment(new Date()));
        if (!isPrevDate) {
          handleTimingSelected(current_time);
          handleDateSelected(current_time);
          handleShowTimingSelected(true);
          setCurrentTimeFromURLParams(true);
        }
        // showFormAndTimingSelected();
      }
    }
  },
  // eslint-disable-next-line
  []);

  // check width
  useEffect(() => {
      if(showTimingList){
        if(width <= 850){
          setShowBookingCalendar(false);
        }
        else{
          setShowBookingCalendar(true);
          handleShowTimingList(true);
          handleConfirmButton(false);
        }
      }
      else if(showConfirmation){
        handleConfirmButton(false)
      }
  }, 
  // eslint-disable-next-line
  [width]);

  useEffect(() => {
    if(showBookingCalendar){
      // setShowTimingList(false);
      if(width <= 850) {
        handleConfirmButton(true);
      }
      else {
        handleConfirmButton(false);
      }
      
      handleShowForm(false);
      // setDateSelected(null);
      if (!URL_PARAMS) handleTimingSelected(null);
      setShowConfirmation(false);
    }
  }, 
  // eslint-disable-next-line
  [showBookingCalendar]);

  useEffect(() => {
    if(showTimingList){
      if(width <= 850) setShowBookingCalendar(false)
      else setShowBookingCalendar(true);
      handleShowForm(false);
      if (!URL_PARAMS) handleTimingSelected(null);
    }
  }, 
  // eslint-disable-next-line
  [showTimingList]);

  useEffect(() => {
    if(showForm){
      window.scrollTo(0, 0);
      setShowBookingCalendar(false);
      handleShowTimingList(false);
      handleShowForm(true);
    }
    
  }, 
  // eslint-disable-next-line
  [showForm]);

  useEffect(() => {
    if(dateSelected){
      var current_date_time = new Date(dateSelected);
      var key = `${current_date_time.getDate()}-${("0" + (current_date_time.getMonth() + 1)).slice(-2)}-${current_date_time.getFullYear()}`;
      // remove selected class
      var day_elements = document.getElementsByClassName('day');
      for(let i = 0; i<= day_elements.length; i++){
        
        if(day_elements[i] && day_elements[i].classList.contains('selected')){
          let data_key = day_elements[i].getAttribute('data-value');
          
          if (!isShareDateTime || (data_key && (!shareTimings[data_key] || shareTimings[data_key].length === 0))) {
            day_elements[i].classList.remove('selected');

            day_elements[i].style.backgroundColor = `#${Colors.white}`;
            day_elements[i].style.color = `${color}`;
          }
          
        }
      }

      if (!isShareDateTime || (Object.keys(shareTimings).length < 7 || Object.keys(shareTimings).includes(key))) {
        var element = document.querySelector(`[data-id='${dateSelected}']`);
        if (element) {
          element.classList.add('selected');
          element.style.backgroundColor = hex_to_rgba(color, 0.15);
          element.style.color = `${color}`;
          element.style.borderColor = `${color}`;
        }

        if(width >= 850) {
          handleShowTimingList(true);
        }
        else {
          handleConfirmButton(true);
        }
      }
      else {
        handleShowTimingList(false);
      }
    }
  },
  // eslint-disable-next-line
  [dateSelected]);

  useEffect(() => {    
    setShowConfirmation(false);
    if(isCancelMeeting) {
      handleShowForm(true);
      handleDateSelected(null);
    } 
    else {
      handleShowForm(false);
      setShowBookingCalendar(true);
    }
  }, 
  // eslint-disable-next-line
  [isCancelMeeting]);  

  useEffect(() => {
    if (currentTimeFromURLParams && timingSelected && !isShareDateTime && Object.keys(data).length > 0) {
      handleShowForm(true);
    }
  },
  // eslint-disable-next-line
  [currentTimeFromURLParams, timingSelected, data])


  const nextShowForm = () => {
    handleShowForm(true);
    handleShowTimingSelected(true);
  };

  const nextShowTimingList = () => {
    handleShowTimingList(true);
  }

  // callback function to show form
  useImperativeHandle(ref, () => ({
    nextShowComponent() {
      // setShowForm(true);
      // handleShowTimingSelected(true);
      if(showBookingCalendar) {
        nextShowTimingList();
      }
      else if(showTimingList){
        if (!isShareDateTime) {
          nextShowForm();
        }
        else {
          setShowBookingCalendar(true);
          handleShowTimingList(false);
          handleConfirmButton(false);   
        }
      }
    }
  }));
  
  useImperativeHandle(backButtonRef, () => ({
    backOnClick() {
      if(isCancelMeeting && !showConfirmation){
        cancelMeeting(false, true);
      }
      else{
        if(showBookingCalendar){
          callbackBackButton();
        }
        else if(showTimingList){
          setShowBookingCalendar(true);
          handleShowTimingList(false);
          handleConfirmButton(false);
          handleTimingSelected(null);
          handleDateSelected(null);        
        }
        else if(showForm && !showConfirmation){
          handleShowTimingList(true);
          handleTimingSelected(null);
        }
        else if(showConfirmation){
          setShowBookingCalendar(true);
          handleShowTimingList(false);
          handleTimingSelected(null);
          handleDateSelected(null);
        }
      }
    }
  }))

  // callback function to generate callback for button back icon
  const callbackBackButton = () => {
    if(showBookingCalendar && (type === 'question' || type === 'event')){
      let href= '';
      if(type === 'question'){
        href = `/event/${meetingId}/${data['question']['parent_question_id']}${locationSearch}`;
      }
      else if(type === 'event'){
        if(typeUser === 'user')
          href = `/${userTeamPathId}`;
        else if(typeUser === 'team') href = `/t/${userTeamPathId}`;
      }

      return window.location.href = href;
    }

    if(isCancelMeeting && !showConfirmation){
      return backArrowClicked;
    }
  };

  // const headerBackElement = () => {
  //   if((!locationSearch && type !== 'question') && (isCancelMeeting || isReschedule)) return null;
  //   if(width > 858 && !showForm){
  //     return(
  //       <PrevIcon handleOnClick={() => callbackBackButton()} />
  //     );
  //   }
  // };

  const headerTitleText = () => {
    if((showForm && !isCancelMeeting) || showConfirmation || showPreviewShareEmail) return null;
    
    if(showTimingList || showBookingCalendar){
      return t('Choose Date & Time');
    }
  };

  const backArrowClicked = (type = null) => {
    if(isCancelMeeting){
      setBackToReschedule();
      setShowBookingCalendar(true);
    }
    else{
      handleShowForm(false);
      handleShowTimingList(false);
      setShowBookingCalendar(false);
      
      if(type === 'date_selected'){
        setShowBookingCalendar(true);
      }
      else if(type === 'timing_selected'){
        handleShowTimingList(true);
      }
    }
  }

  const clearDay = () => {
    handleDateSelected(null);
    handleTimingSelected(null);

    // remove the timeslot
    removeTimeslot(timingKey, timingSelected);

    // hide header text
    hideHeaderText();
  };

  const handleDayClicked = (date) => {
    handleDateSelected(date);
  };

  const handleTimeClicked = (time) => {
    handleTimingSelected(time);
    if (currentTimeFromURLParams) {
      setCurrentTimeFromURLParams(false);
    }
    // handleShowTimingSelected(false);
  };

  const handleFormBackButton = async() => {
    if(isCancelMeeting && !isReschedule){
      await cancelMeeting(false, true);
    }
    else{
      setShowBookingCalendar(true);
      handleShowTimingList(false);
      handleDateSelected(null);
      handleTimingSelected(null);
      handleShowTimingSelected(false);
    }
  };

  // callback function when user submitted the schedule and clicked the back button
  const handleBackAfterConfirmation = async() => {
    setShowBookingCalendar(true);
    await handleCancelMeetingButton(true);
  }

  // callback function when change the month -> prev/next (current month selected)
  const handleChangeTimingKey = (key) => {
    setTimingKey(key);
  };

  // callback function when confrimation shown
  const hideHeaderText = async() => {
    setShowConfirmation(true);
    await handleCancelMeetingButton(false);
  };

  // hide timing list
  const hideTimingList = () => {
    handleShowTimingList(false);
  };

  // clear day and timing
  const clearDayTiming = () => {
    handleDateSelected(null);
    handleTimingSelected(null);
  };

  return(
    <>
      <div className="top-header">
        {/* { headerBackElement() } */}
      </div>

      <div className="content-wrap-overflow" style={ isShareDateTime ? { padding: 0, alignItems: 'flex-start' } : {}}>
        <div className="content-booking">
          {/* { (isReschedule && (!showForm && !showConfirmation)) && (
            <div className="reschedule-former-time-wrap" style={ (showTimingList || showForm) ? { margin: '0 auto' } : {}}>
              <div className="reshedule-former-time-header">
                {t('Previous schedule you selected')}
              </div>

              <div className="reschedule-former-time-detail">
                <div className="date">{`${t(moment(data['current_timing'], 'x').format("dddd"))}, ${moment(data['current_timing'], 'x').format("DD")} ${t(moment(data['current_timing'], 'x').format("MMMM"))} ${moment(data['current_timing'], 'x').format("YYYY")}`}</div>
                <div className="time">
                  { (data['iso_time'] === true) ?
                    `${moment(data['current_timing'], 'x').format("HH:mm")} - ${moment(data['current_timing']).add(data['time_interval'], 'minutes').format('HH:mm')}` :
                    `${moment(data['current_timing'], 'x').format("hh:mm a")} - ${moment(data['current_timing']).add(data['time_interval'], 'minutes').format('hh:mm a')}`
                  }
                </div>
                <div className="timezone">{ `${Object.values(ct.getAllTimezones()).find(x => x.utcOffset === moment(data['current_timing'], 'x').utcOffset()).name || '-'} (UTC${moment(data['current_timing'], 'x').format('Z')})` }</div>
              </div>
            </div>
          )} */}

          <div style={{ position: 'relative' }}>
            <div className="header-booking">
              <p>{ headerTitleText() }</p>
            </div>

            { !isCancelMeeting && (
              <div className="booking-calendar-timing">
                { showBookingCalendar && !showPreviewShareEmail && (
                  <div className="calendar-booking-wrap">
                    <Calendar 
                      timingsData={timingsData}
                      timezoneName={timezoneName}
                      color={color}
                      timingPath={timingPath}
                      getTimings={getTimings}
                      isReschedule={isReschedule}
                      isCancelMeeting={isCancelMeeting}
                      handleDayClicked={handleDayClicked}
                      handleChangeTimingKey={handleChangeTimingKey}
                      handleChangeTimezone={handleChangeTimezone}
                      rescheduleURL={data['reschedule_url']}
                      cancelURL={data['cancel_url']}
                      paymentSettings={data['payment_settings']}
                      chargeDetail={data['charge']}
                      hideTimingList={hideTimingList}
                      dateSelected={dateSelected}
                      clearDayTiming={clearDayTiming}
                      showTimingList={showTimingList}
                      weekFormat={data['week_format']}
                      isoTime={data['iso_time']}
                      timingSelected={timingSelected}
                      isShareDateTime={isShareDateTime}
                      shareTimings={shareTimings} />
                    </div>
                )}

                { showTimingList && (
                  <TimingList
                    handleTimeClicked={handleTimeClicked}
                    dateSelected={dateSelected}
                    timezoneName={timezoneName}
                    timingsData={timingsData}
                    timingKey={timingKey}
                    timingSelected={timingSelected}
                    color={color}
                    handleConfirmButton={handleConfirmButton} // to show confirm button
                    nextShowForm={nextShowForm}
                    isoTime={data['iso_time']}
                    isShareDateTime={isShareDateTime}
                    shareTimings={shareTimings} />
                )}
              </div>
            )}              
            
            { (!isShareDateTime && showForm && data) && (
              <FormField
                ref={createRef("modal")}
                uid={data['uid']}
                isReschedule={isReschedule}
                color={color}
                locationSearch={locationSearch}
                formElements={data['form_elements']}
                defaultElements = {data['default_elements']}
                show={showForm}
                countryCode={countryCode}
                permittedCountries={data['permitted_countries']} 
                customDisplayedCountries={data['custom_displayed_countries']} 
                defaultCountry={data['default_country']}
                acceptPayment={data?.payment_settings?.accept_payment}
                timezoneName={timezoneName} 
                times={timingSelected}
                formURL={data['form_url']}
                method={data['method']}
                facebookPixel={ReactPixel} 
                googleAnalytics={ReactGA}
                googleAnalytics4={ReactGA4}
                clearDay={clearDay}
                hideHeaderText={hideHeaderText}
                handleBackAfterConfirmation={handleBackAfterConfirmation}
                handleBackButton={handleFormBackButton}
                name={data['name']}
                location={data['location']}
                isCancelMeeting={isCancelMeeting}
                rescheduleURL={data['reschedule_url']}
                cancelURL={data['cancel_url']}
                paymentSettings={data['payment_settings']}
                chargeDetail={data['charge']}
                handleConfirmButton={handleConfirmButton}
                handleFormSubmitRef={handleFormSubmitRef}
                languageCode={languageCode}
                redirectStatus={redirectStatus}
                redirectLink={redirectLink}
                isoTime={data['iso_time']}
                timeInterval={data['time_interval']}
                locationOptions={locationOptions}
                currentDuration={currentDuration}
                scheduleLocation={scheduleLocation} />
            )}
          </div>
        </div>

        { !showPreviewShareEmail && showBookingCalendar && isShareDateTime && (
            <div style={{ display: 'flex', flexDirection: 'column', height: (width > 858) ? 'auto' : '11rem'}}>
              <Info
                timeSlots={timeSlots}
                datesSelected={datesSelected}
                color={color} />
              
              { width > 858 && (
                <ButtonNext
                  shareTimings={shareTimings}
                  onClick={showPreviewShare} />
              )}
              </div>
          )}
      </div>
    </>
  );
});

export default Booking;